module.exports = __webpack_public_path__ + "public/Icons/gotoSite.svg?ffadbea0";